import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/app/web/app/components/base/toast/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/app/components/browser-initor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/app/components/i18n.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/app/components/sentry-initor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/app/routePrefixHandle.tsx");
;
import(/* webpackMode: "eager" */ "/app/web/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/web/app/styles/markdown.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/web/context/global-public-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TanstackQueryIniter"] */ "/app/web/context/query-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["changeLanguage"] */ "/app/web/i18n/i18next-config.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/web/node_modules/.pnpm/next-themes@0.4.6_react-dom@19.0.1_react@19.0.1__react@19.0.1/node_modules/next-themes/dist/index.mjs");
